// src/UserContext.js
import React, { createContext, useState, useContext } from 'react';

const UserContext = createContext();

function getCookie(cookieName) {
  const cookies = document.cookie.split(';');
  for (let cookie of cookies) {
    const [name, value] = cookie.trim().split('=');
    if (name === cookieName) {
      return decodeURIComponent(value);
    }
  }
  return null;
}

export const UserProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [cards, setCards] = useState([]);
  const [filters, setFilters] = useState([]);
  const [settings, setSettings] = useState({
    cardsPerRow: localStorage.getItem('cardsPerRow') || 2,
    language: getCookie('language_creator') || 'en',
    darkMode: localStorage.getItem('darkMode') || false,
    popoutPreview: localStorage.getItem('popoutPreview') !== 'false',
    artPanDampening: parseFloat(localStorage.getItem('artPanDampening')) || 0.6,
    cardTitleStyle: localStorage.getItem('cardTitleStyle') || 'game-like',
    customAutobold: localStorage.getItem('customAutobold') || '',
  });

  const [organizerDataVersion, setOrganizerDataVersion] = useState(0);
  const refreshOrganizerData = () => setOrganizerDataVersion(v => v + 1);

  return (
    <UserContext.Provider value={{ user, setUser, filters, setFilters, settings, setSettings, cards, setCards, organizerDataVersion, refreshOrganizerData }}>
      {children}
    </UserContext.Provider>
  );
};

export const useUser = () => useContext(UserContext);
